/** Canonical prefix that every grant secret of a Looker instance starts with.
 * Other providers rewrite it with their `replacer`: in Google Secret Manager
 * it becomes `p0_access-token_looker_<instanceId>_`, the prefix that the
 * connector's Terraform lets it write. */
export const lookerAiAccessTokenPrefix = (instanceId: string): string =>
  `p0/access-token/looker/${instanceId}/`;
